module.exports = __webpack_public_path__ + "static/media/hangman5.485f0ac3.png";